(() => {
  if (window.ssCollectionInitialized) return;
  window.ssCollectionInitialized = true;
  const query = () => document.querySelector('[data-ss-collection]');
  const preserveOfferContext = input => document.querySelector('ss-collection-offer')?.preserveContext?.(input) || input;
  // Older saved links used the label instead of the canonical metafield value.
  function canonicalFilterURL(input) {
    const url = new URL(input, location.origin);
    const key = 'filter.p.m.custom.print_size';
    const values = url.searchParams.getAll(key);
    if (!values.includes('Large Print')) return url;
    url.searchParams.delete(key);
    [...new Set(values.map(value => value === 'Large Print' ? 'Large' : value))]
      .forEach(value => url.searchParams.append(key, value));
    return url;
  }
  let pending, dialogDraft, previousOverflow, rowFillController, rowFillObserver;
  let floatingObserver, refreshFloating, filterOpener;
  const observers = new Map();
  const mobileFeatures = window.matchMedia('(max-width:700px)');
  mobileFeatures.addEventListener('change', () => refreshFloating?.());
  function positionBibleFeatures(root) {
    const grid = root?.querySelector('[data-ss-product-grid]');
    if (!grid) return;
    const features = [...grid.querySelectorAll(':scope > [data-ss-bible-feature]')];
    if (!features.length) return;
    const slots = mobileFeatures.matches ? [6,11,16,23] : [6,10,17,24];
    const order = ['builder','gift','design','translation'];
    const products = [...grid.children].filter(e => !e.hasAttribute('data-ss-bible-feature'));
    const items = [...products];
    order.forEach((id, index) => {
      const card = features.find(e => e.dataset.ssBibleFeature === id);
      if (card) items.splice(Math.min(slots[index]-1, items.length), 0, card);
    });
    grid.append(...items);
  }
  const desktopRows=window.matchMedia('(min-width:701px)');
  async function completeDesktopRow(root){
    if(!root||!root.isConnected||!desktopRows.matches||root.getAttribute('aria-busy')==='true'||rowFillController)return;
    const grid=root.querySelector('[data-ss-product-grid]'),button=root.querySelector('[data-ss-load-more]');
    if(!grid||!button||!grid.querySelector('[data-ss-bible-feature]'))return;
    const columns=getComputedStyle(grid).gridTemplateColumns.split(/\s+/).filter(Boolean).length;
    const count=[...grid.children].filter(el=>getComputedStyle(el).display!=='none').length;
    const needed=(columns-count%columns)%columns;if(!needed)return;
    rowFillController?.abort();const controller=new AbortController();rowFillController=controller;
    const url=new URL(preserveOfferContext(button.dataset.url),location.origin),current=new URL(location.href);
    if(current.searchParams.has('view'))url.searchParams.set('view',current.searchParams.get('view'));
    url.searchParams.set('section_id',root.dataset.sectionId);
    try{
      const response=await fetch(url,{signal:controller.signal});if(!response.ok)throw new Error('Collection row request failed');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      if(controller.signal.aborted||!root.isConnected||root!==query()||root.getAttribute('aria-busy')==='true'||!desktopRows.matches)return;
      const existing=new Set([...grid.querySelectorAll('[data-product-id]')].map(el=>el.dataset.productId));
      const currentColumns=getComputedStyle(grid).gridTemplateColumns.split(/\s+/).filter(Boolean).length;
      const currentCount=[...grid.children].filter(el=>getComputedStyle(el).display!=='none').length;
      const currentNeeded=(currentColumns-currentCount%currentColumns)%currentColumns;
      const extras=[...doc.querySelectorAll('[data-ss-product-grid]>.home-soft-card')].filter(el=>!existing.has(el.dataset.productId)).slice(0,currentNeeded);
      extras.forEach(el=>{el.setAttribute('data-ss-desktop-extra','');grid.append(el);});reviews(root);
    }catch(error){if(error.name!=='AbortError')console.warn('Desktop Bible row could not be completed',error);}
    finally{if(rowFillController===controller)rowFillController=null;}
  }
  mobileFeatures.addEventListener('change', () => {positionBibleFeatures(query());completeDesktopRow(query());});
  window.addEventListener('resize',()=>{if(desktopRows.matches)completeDesktopRow(query());});
  const star = '<span class="ss-review-star" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="m12 2 3 6.3 7 .9-5 4.9 1.2 7-6.2-3.3-6.2 3.3 1.2-7-5-4.9 7-.9Z"/></svg></span>';
  function reviews(root) {
    root.querySelectorAll('.home-card-reviews').forEach(widget => {
      if (observers.has(widget)) return;
      const format = () => {
        const badge = widget.querySelector('.jdgm-prev-badge');
        if (!badge) return;
        const count = Number(badge.dataset.numberOfReviews), rating = Number(badge.dataset.averageRating);
        const text = badge.querySelector('.jdgm-prev-badge__text');
        if (!text || !Number.isFinite(rating) || count <= 0) return;
        const summary = `${rating.toFixed(1)} (${count})`;
        if (text.textContent !== summary) text.textContent = summary;
        if (!badge.querySelector('.ss-review-star')) badge.insertAdjacentHTML('afterbegin', star);
        widget.setAttribute('aria-label', `Rated ${rating.toFixed(1)} out of 5 from ${count} reviews`);
        widget.setAttribute('role', 'link');
        widget.tabIndex = 0;
      };
      format();
      const observer = new MutationObserver(format);
      observer.observe(widget, {childList:true,subtree:true,attributes:true,attributeFilter:['data-average-rating','data-number-of-reviews']});
      observers.set(widget, observer);
    });
  }
  function status(root, key) {
    const el = root.querySelector('[data-ss-status]');
    el.textContent = el.dataset[key] || '';
    el.classList.toggle('is-error', key === 'error');
  }
  function closeFilters(root, restore = true) {
    const dialog = root.querySelector('[data-ss-filter-dialog]');
    if (dialog.open) dialog.close();
    if (restore && dialogDraft) {
      const form = root.querySelector('[data-ss-filter-form]');
      form.querySelectorAll('input').forEach(input => {
        if (input.type === 'checkbox') input.checked = dialogDraft.getAll(input.name).includes(input.value);
        else input.value = dialogDraft.get(input.name) ?? '';
      });
    }
    const form = root.querySelector('[data-ss-filter-form]');
    root.querySelector('[data-ss-filter-home]').insertBefore(form, root.querySelector('.ss-sidebar-help'));
    document.body.style.overflow = previousOverflow ?? '';
    dialogDraft = null;
    refreshFloating?.();
    if (restore && filterOpener?.isConnected) filterOpener.focus({preventScroll:true});
    filterOpener = null;
  }
  function openFilters(root, translations = false) {
    filterOpener = document.activeElement;
    const form = root.querySelector('[data-ss-filter-form]'), dialog = root.querySelector('[data-ss-filter-dialog]');
    dialogDraft = new FormData(form);
    root.querySelector('[data-ss-filter-slot]').append(form);
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.showModal();
    refreshFloating?.();
    if (translations) {
      const group = form.querySelector('[data-filter-group="filter.p.m.custom.translation"]');
      if (group) { group.open = true; group.scrollIntoView({block:'start'}); }
    }
  }
  function syncBrowse(root) {
    const current = new URL(location.href);
    let selected = null, specificity = 0;
    root.querySelectorAll('[data-ss-browse-chip]').forEach(chip => {
      const target = new URL(chip.href, location.origin);
      const sameCollection = target.origin === current.origin && target.pathname === current.pathname;
      if (sameCollection) chip.setAttribute('data-ss-collection-link', '');
      const entries = [...target.searchParams];
      const presetTag = root.dataset.presetTabs === 'true' && target.pathname !== root.dataset.collectionUrl;
      const matches = sameCollection && (entries.length > 0 || presetTag) && entries.every(([key, value]) => current.searchParams.getAll(key).includes(value));
      const weight = entries.length + (presetTag ? 1 : 0);
      if (matches && weight > specificity) { selected = chip; specificity = weight; }
      chip.classList.remove('is-active');
      chip.removeAttribute('aria-current');
    });
    const all = root.querySelector('[data-ss-browse-all]');
    const defaultTranslation = root.dataset.defaultTranslation;
    const hasFilters = (root.dataset.presetTabs === 'true' && current.pathname !== root.dataset.collectionUrl) || [...current.searchParams.keys()].some(key => key.startsWith('filter.') && !(key === 'filter.p.m.custom.translation' && defaultTranslation && current.searchParams.getAll(key).length === 1 && current.searchParams.get(key) === defaultTranslation));
    if (!selected && !hasFilters) selected = all;
    all.classList.toggle('is-active', selected === all);
    all.removeAttribute('aria-current');
    if (selected) {
      selected.classList.add('is-active'); selected.setAttribute('aria-current', 'true');
      const rail = root.querySelector('.ss-shop-rail');
      const itemRect = selected.getBoundingClientRect(), railRect = rail.getBoundingClientRect();
      if (itemRect.right > railRect.right) rail.scrollLeft += itemRect.right - railRect.right;
      else if (itemRect.left < railRect.left) rail.scrollLeft -= railRect.left - itemRect.left;
    }
  }
  function initialize(root) {
    if (!root) return;
    document.querySelector('ss-collection-offer')?.refresh?.();
    positionBibleFeatures(root);
    root.classList.add('ss-js');
    syncBrowse(root);
    reviews(root);
    rowFillObserver?.disconnect();rowFillObserver=new ResizeObserver(()=>completeDesktopRow(root));const rowGrid=root.querySelector('[data-ss-product-grid]');if(rowGrid)rowFillObserver.observe(rowGrid);
    requestAnimationFrame(()=>completeDesktopRow(root));
    floatingObserver?.disconnect();
    const floating = root.querySelector('[data-ss-floating-filter]');
    const toolbar = root.querySelector('.ss-catalog-toolbar');
    const catalog = root.querySelector('.ss-catalog-layout');
    refreshFloating = () => {
      // This control is hidden on mobile; skip its layout reads after dialog writes.
      if (mobileFeatures.matches) { floating.hidden = true; return; }
      const sidebarFilters = root.querySelector('.ss-catalog-sidebar [data-ss-filter-form]');
      const sidebarVisible = sidebarFilters && getComputedStyle(sidebarFilters.closest('.ss-catalog-sidebar')).display !== 'none';
      const originalBottom = Math.max(toolbar.getBoundingClientRect().bottom, sidebarVisible ? sidebarFilters.getBoundingClientRect().bottom : 0);
      floating.hidden = originalBottom > 0 || catalog.getBoundingClientRect().bottom < 120 || root.querySelector('[data-ss-filter-dialog]').open;
    };
    if ('IntersectionObserver' in window) {
      floatingObserver = new IntersectionObserver(refreshFloating, {rootMargin:'0px 0px -120px 0px',threshold:[0,1]});
      floatingObserver.observe(toolbar);
      floatingObserver.observe(catalog);
      const sidebarFilters = root.querySelector('.ss-catalog-sidebar [data-ss-filter-form]');
      if (sidebarFilters) floatingObserver.observe(sidebarFilters);
      refreshFloating();
    }
    const dialog = root.querySelector('[data-ss-filter-dialog]');
    dialog.addEventListener('cancel', event => { event.preventDefault(); closeFilters(root); });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeFilters(root);
    });
  }
  function formURL(root) {
    const url = new URL(root.dataset.presetTabs === 'true' ? location.pathname : root.dataset.collectionUrl, location.origin);
    const current = new URL(location.href);
    if (current.searchParams.has('view')) url.searchParams.set('view', current.searchParams.get('view'));
    for (const [key, value] of new FormData(root.querySelector('[data-ss-filter-form]'))) {
      if (String(value).trim()) url.searchParams.append(key, value);
    }
    return preserveOfferContext(url);
  }
  async function update(url, {more = false, history = true, replace = false} = {}) {
    let root = query();
    if (!root) return;
    const originalURL = new URL(preserveOfferContext(url), location.origin);
    url = canonicalFilterURL(originalURL);
    const normalized = originalURL.href !== url.href;
    pending?.abort(); rowFillController?.abort(); rowFillController=null;
    const controller = new AbortController(); pending = controller;
    const requestURL = new URL(url, location.origin);
    requestURL.searchParams.set('section_id', root.dataset.sectionId);
    root.setAttribute('aria-busy', 'true'); status(root, 'loading');
    const button = root.querySelector('[data-ss-load-more]');
    if (more && button) button.setAttribute('aria-disabled', 'true');
    const openGroups = [...root.querySelectorAll('[data-filter-group][open]')].map(e => e.dataset.filterGroup);
    try {
      const response = await fetch(requestURL, {signal:controller.signal});
      if (!response.ok) throw new Error('Collection request failed');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = doc.querySelector('[data-ss-collection]');
      if (!next) throw new Error('Collection section missing');
      if (more) {
        const products = next.querySelectorAll('[data-ss-product-grid]>.home-soft-card, [data-ss-product-grid]>[data-ss-bible-feature]');
        if (!products.length) throw new Error('No products received');
        const grid=root.querySelector('[data-ss-product-grid]');
        const existingProducts=new Map([...grid.querySelectorAll('[data-product-id]')].map(el=>[el.dataset.productId,el]));
        const existingFeatures=new Set([...grid.querySelectorAll('[data-ss-bible-feature]')].map(el=>el.dataset.ssBibleFeature));
        products.forEach(el=>{
          if(el.hasAttribute('data-product-id')){
            const existing=existingProducts.get(el.dataset.productId);
            if(existing){existing.removeAttribute('data-ss-desktop-extra');return;}
            existingProducts.set(el.dataset.productId,el);
          }else if(el.hasAttribute('data-ss-bible-feature')){
            if(existingFeatures.has(el.dataset.ssBibleFeature))return;existingFeatures.add(el.dataset.ssBibleFeature);
          }
          grid.append(el);
        });
        positionBibleFeatures(root);
        button?.remove();
        const nextButton = next.querySelector('[data-ss-load-more]');
        if (nextButton) root.querySelector('.ss-load-section').prepend(nextButton);
        reviews(root); status(root, '');
      } else {
        if (root.querySelector('[data-ss-filter-dialog]').open) closeFilters(root, false);
        observers.forEach((observer, widget) => { if (root.contains(widget)) { observer.disconnect(); observers.delete(widget); } });
        root.replaceWith(next); root = next;
        root.querySelectorAll('[data-filter-group]').forEach(e => { if (openGroups.includes(e.dataset.filterGroup)) e.open = true; });
        if (history || normalized) window.history[replace || normalized ? 'replaceState' : 'pushState']({}, '', url);
        initialize(root);
        status(root, '');
        const toolbar = root.querySelector('.ss-catalog-toolbar');
        if (toolbar.getBoundingClientRect().top < 66) toolbar.scrollIntoView({block:'start'});
      }
    } catch (error) {
      if (error.name !== 'AbortError') { root.querySelector('.ss-catalog-layout').hidden = false; status(root, 'error'); button?.removeAttribute('aria-disabled'); }
    } finally {
      if (pending === controller) { root.removeAttribute('aria-busy'); pending = null; requestAnimationFrame(()=>completeDesktopRow(root)); }
    }
  }
  document.addEventListener('click', event => {
    const root = event.target.closest('[data-ss-collection]');
    if (!root) return;
    const target = event.target.closest('a,button,.home-card-reviews');
    if (!target) return;
    if (target.matches('[data-ss-open-filters],[data-ss-more-translations]')) openFilters(root, target.matches('[data-ss-more-translations]'));
    if (target.matches('[data-ss-close-filters]')) closeFilters(root);
    if (target.matches('[data-ss-clear-draft]')) {
      root.querySelectorAll('[data-ss-filter-form] input').forEach(input => { if (input.type === 'checkbox') input.checked = false; else if (input.type !== 'hidden') input.value = ''; });
    }
    if (target.matches('[data-ss-apply-filters]')) { const url = formURL(root); closeFilters(root, false); update(url); }
    if (target.matches('[data-ss-collection-link],[data-ss-load-more]') && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
      event.preventDefault();
      const url = new URL(target.dataset.url || target.href, location.origin);
      const current = new URL(location.href);
      if (current.searchParams.has('view')) url.searchParams.set('view', current.searchParams.get('view'));
      if (target.hasAttribute('data-ss-preset')) {
        // Presets replace all active facets; only the sidebar combines them.
        url.searchParams.delete('page');
        url.searchParams.delete('section_id');
        if (!url.searchParams.has('sort_by') && current.searchParams.has('sort_by')) url.searchParams.set('sort_by', current.searchParams.get('sort_by'));
      }
      update(url, {more:target.hasAttribute('data-ss-load-more')});
    }
    if (target.matches('.home-card-reviews')) {
      const link = target.closest('.home-soft-card').querySelector('.v2-product-photo');
      location.assign(link.href + '#judgeme_product_reviews');
    }
  });
  document.addEventListener('change', event => {
    const root = event.target.closest('[data-ss-collection]');
    if (!root) return;
    if (event.target.closest('[data-ss-sort-form]')) {
      const url = new URL(location.href); url.searchParams.delete('page'); url.searchParams.set('sort_by', event.target.value); update(url);
    } else if (event.target.closest('[data-ss-filter-form]') && !root.querySelector('[data-ss-filter-dialog]').open) update(formURL(root));
  });
  document.addEventListener('submit', event => {
    const root = event.target.closest('[data-ss-collection]');
    if (!root || !event.target.matches('[data-ss-filter-form],[data-ss-sort-form]')) return;
    event.preventDefault(); update(formURL(root));
  });
  document.addEventListener('keydown', event => {
    const reviews = event.target.closest('.ss-collection .home-card-reviews');
    if (reviews && (event.key === 'Enter' || event.key === ' ')) { event.preventDefault(); reviews.click(); }
  });
  window.addEventListener('popstate', () => { if (query()) update(location.href, {history:false}); });
  document.addEventListener('shopify:section:load', () => initialize(query()));
  const initial = query();
  initialize(initial);
  const initialURL = canonicalFilterURL(location.href);
  if (initial?.dataset.defaultTranslation) {
    if (!initialURL.searchParams.has('filter.p.m.custom.translation')) {
      initialURL.searchParams.set('filter.p.m.custom.translation', initial.dataset.defaultTranslation);
    }
  }
  if (initial && initialURL.href !== location.href) update(initialURL, {replace:true});
})();
